"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesforceRecordTypes;
(function (SalesforceRecordTypes) {
    SalesforceRecordTypes["ACCOUNT"] = "Account";
    SalesforceRecordTypes["PERSON_ACCOUNT"] = "Person Account";
    SalesforceRecordTypes["SERVICE_CONTRACT"] = "ServiceContract";
    SalesforceRecordTypes["CONTRACT_LINE_ITEM"] = "ContractLineItem";
    SalesforceRecordTypes["CONTACT"] = "Contact";
    SalesforceRecordTypes["PRICE_BOOK_ENTRY"] = "PricebookEntry";
    SalesforceRecordTypes["ACCOUNT_CONTACT_RELATION"] = "AccountContactRelation";
    SalesforceRecordTypes["ORDER"] = "Order";
    SalesforceRecordTypes["ACCOUNT_PERSON_ACCOUNT"] = "Account_Person_Account__c";
    SalesforceRecordTypes["CONTACT_POINT_EMAIL"] = "ContactPointEmail";
    SalesforceRecordTypes["CONTACT_POINT_ADDRESS"] = "ContactPointAddress";
    SalesforceRecordTypes["INDIVIDUAL"] = "Individual";
    SalesforceRecordTypes["TAX_EXEMPT"] = "RV_TaxExempt__c";
    SalesforceRecordTypes["MEMBERSHIP"] = "Membership__c";
    SalesforceRecordTypes["MEMBERSHIP_TERM"] = "Membership_Term__c";
    SalesforceRecordTypes["QUOTE"] = "RV_Quote__c";
    SalesforceRecordTypes["QUOTE_GROUP"] = "Quote_Group__c";
    SalesforceRecordTypes["QUOTE_LINE_ITEM"] = "RV_QuoteLineItem__c";
    SalesforceRecordTypes["SUPPRESSION"] = "Suppression__c";
    SalesforceRecordTypes["SUPPRESSION_PART"] = "Suppression_Part__c";
    SalesforceRecordTypes["PER_PORTFOLIO"] = "PER_Portfolio__c";
    SalesforceRecordTypes["PRACTICAL_EXPERIENCE_REQUIREMENTS_MODULE"] = "PER__c";
    SalesforceRecordTypes["PER_EXTERNAL_VALIDATOR"] = "External_Validator__c";
    SalesforceRecordTypes["PER_AUDIT"] = "PER_Audit__c";
    SalesforceRecordTypes["FEEDBACK"] = "Feedback__c";
    SalesforceRecordTypes["EXAM_CREDIT"] = "Exam_Credit__c";
    SalesforceRecordTypes["PEER_REVIEW"] = "Peer_Review_Record__c";
    SalesforceRecordTypes["ATTESTATION"] = "Attestation__c";
    SalesforceRecordTypes["APPRENTICE_GATEWAY"] = "Apprentice_Gateway__c";
    SalesforceRecordTypes["APPLICATION_PART"] = "Application_Part__c";
    SalesforceRecordTypes["CASE"] = "Case";
    SalesforceRecordTypes["EXAM_BOOKING"] = "Exam_Booking__c";
    SalesforceRecordTypes["EXAM"] = "Exam__c";
    SalesforceRecordTypes["EXAM_AUTHORISATION"] = "Exam_Authorisation__c";
    SalesforceRecordTypes["PV_EXAM_AUTHORISATION_EAD"] = "PV_Exam_Authorisation_EAD__c";
    SalesforceRecordTypes["PERSON_SPECIAL_ACCOMMODATION"] = "Person_Special_Accommodation__c";
    SalesforceRecordTypes["PERSON_QUALIFICATION_LEVEL"] = "Person_Qualification_Level__c";
    SalesforceRecordTypes["PERSON_EXAM_EXEMPTION"] = "Person_Exam_Exemption__c";
    SalesforceRecordTypes["SECTION_TERM"] = "Section_Term__c";
    SalesforceRecordTypes["CREDENTIAL_TERM"] = "Credential_Term__c";
    SalesforceRecordTypes["PAYMENT_MANDATE"] = "Direct_Debit_Mandate__c";
    SalesforceRecordTypes["CIMA_EXAM_RESULT"] = "CIMA_Exam_Result__c";
    SalesforceRecordTypes["PERSON_LEVEL_EXEMPTION"] = "Person_Level_Exemption__c";
    SalesforceRecordTypes["PERSON_CERTIFICATE"] = "Person_Certificate__c";
    SalesforceRecordTypes["CREDENTIAL"] = "Credential__c";
    SalesforceRecordTypes["SECTION"] = "Section__c";
    // FLP
    SalesforceRecordTypes["FLP_COMPETENCY_AREA_RESULT"] = "FLP_Competency_Area_Result__c";
    // JUNCTION
    SalesforceRecordTypes["PERSON_SPECIAL_ACCOMMODATION_EXAM_AUTH_JUNCTION__C"] = "PSpecialAccom_ExamAuth_Junction__c";
    SalesforceRecordTypes["PERSON_SPECIAL_ACCOMMODATION_EXAM_AUTH_EAD_JUNCTION__C"] = "PSpecialAccom_ExamAuthEAD_Junction__c";
    SalesforceRecordTypes["EXAM_CREDIT_EXAM_AUTH_JUNCTION__C"] = "Exam_Credit_Exam_Auth_Junction__c";
    SalesforceRecordTypes["MIP_APPLICATION_BENEFICIAL_OWNER__C"] = "MIP_Application_Beneficial_Owner__c";
    SalesforceRecordTypes["MIP_APPLICATION_DIRECTOR_PARTNER__C"] = "MIP_AML_Director_Partner__c";
    SalesforceRecordTypes["MIP_PRACTICE_DETAILS"] = "MIP_Practice_Details__c";
    SalesforceRecordTypes["MIP_WORK_HISTORY"] = "MIP_Work_History__c";
    SalesforceRecordTypes["MIP_AML_APPLICATION"] = "MIP_AML_Application__c";
    SalesforceRecordTypes["DOCUMENT"] = "Document__c";
    SalesforceRecordTypes["EXAM_SECTION_RESULT"] = "Exam_Section_Result__c";
})(SalesforceRecordTypes = exports.SalesforceRecordTypes || (exports.SalesforceRecordTypes = {}));
var ContactTypes;
(function (ContactTypes) {
    ContactTypes["DECISION_MAKER"] = "Decision maker";
    ContactTypes["IMPLEMENTER_COORDINATOR"] = "Implementer/Coordinator";
    ContactTypes["INFLUENCER"] = "Influencer";
    ContactTypes["STAKEHOLDER"] = "Stakeholder";
    ContactTypes["C_SUITE"] = "C-Suite";
    ContactTypes["INSTRUCTOR"] = "Instructor";
    ContactTypes["RECRUITER"] = "Recruiter";
})(ContactTypes = exports.ContactTypes || (exports.ContactTypes = {}));
var AccountRecordNames;
(function (AccountRecordNames) {
    AccountRecordNames["PERSON_ACCOUNT"] = "Person Account";
    AccountRecordNames["BUSINESS"] = "Business";
    AccountRecordNames["SUPERVISOR_FEEDBACK"] = "Supervisor Feedback";
    AccountRecordNames["CORE_ACTIVITY"] = "Core Work Activity Record Type";
    AccountRecordNames["SKILLS_AND_BEHAVIOR"] = "Skills and Behavior Record Type";
    AccountRecordNames["EMPLOYMENT"] = "Employment History Record Type";
})(AccountRecordNames = exports.AccountRecordNames || (exports.AccountRecordNames = {}));
var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["STARTED"] = "started";
    QuoteStatus["CONFIRMED"] = "confirmed";
    QuoteStatus["REJECTED"] = "rejected";
})(QuoteStatus = exports.QuoteStatus || (exports.QuoteStatus = {}));
var ExamCreditStatus;
(function (ExamCreditStatus) {
    ExamCreditStatus["Available"] = "Available";
    ExamCreditStatus["Used"] = "Used";
    ExamCreditStatus["Deprovisioned"] = "Deprovisioned";
    ExamCreditStatus["Expired"] = "Expired";
})(ExamCreditStatus = exports.ExamCreditStatus || (exports.ExamCreditStatus = {}));
var ExamCimaResultPublicationStatus;
(function (ExamCimaResultPublicationStatus) {
    ExamCimaResultPublicationStatus["Published"] = "Published";
    ExamCimaResultPublicationStatus["NotPublished"] = "Not published";
    ExamCimaResultPublicationStatus["DoNotPublish"] = "Do not publish";
})(ExamCimaResultPublicationStatus = exports.ExamCimaResultPublicationStatus || (exports.ExamCimaResultPublicationStatus = {}));
var ExamCimaResultStatus;
(function (ExamCimaResultStatus) {
    ExamCimaResultStatus["Pass"] = "Pass";
    ExamCimaResultStatus["Fail"] = "Fail";
    ExamCimaResultStatus["NoShow"] = "No Show";
    ExamCimaResultStatus["Pending"] = "Pending";
    ExamCimaResultStatus["NdaRefuse"] = "NDA Refused";
})(ExamCimaResultStatus = exports.ExamCimaResultStatus || (exports.ExamCimaResultStatus = {}));
var PersonExamExemptionStatus;
(function (PersonExamExemptionStatus) {
    PersonExamExemptionStatus["Approved"] = "Approved";
    PersonExamExemptionStatus["Waived"] = "Waived";
    PersonExamExemptionStatus["Pending"] = "Pending";
    PersonExamExemptionStatus["Rejected"] = "Rejected";
})(PersonExamExemptionStatus = exports.PersonExamExemptionStatus || (exports.PersonExamExemptionStatus = {}));
var DeprovisionReason;
(function (DeprovisionReason) {
    DeprovisionReason["EXAM_CREDIT_REFUND"] = "Exam credit refund";
    DeprovisionReason["SEAT_DEALLOCATION"] = "Seat deallocation";
    DeprovisionReason["GATEWAY_BUNDLE_REFUND_CANCELLATION"] = "Gateway bundle refund/cancellation";
    DeprovisionReason["REMOVED_FIRM_BILLING"] = "Removed from Firm Billing";
    DeprovisionReason["NON_RENEWAL"] = "Expired CIMA subscription due to non-renewal";
    DeprovisionReason["NON_PAYMENT"] = "Cancelled CIMA subscription due to non-payment";
    DeprovisionReason["PATHWAY_SWITCHED"] = "Pathway Switched";
})(DeprovisionReason = exports.DeprovisionReason || (exports.DeprovisionReason = {}));
var ExamRegistrationMethod;
(function (ExamRegistrationMethod) {
    ExamRegistrationMethod["VUE_WEBSITE"] = "Vue Website";
    ExamRegistrationMethod["VUE_REGISTRATION_CENTER"] = "Vue Registration Center";
})(ExamRegistrationMethod = exports.ExamRegistrationMethod || (exports.ExamRegistrationMethod = {}));
var ExamStatus;
(function (ExamStatus) {
    ExamStatus["Active"] = "Active";
    ExamStatus["Cancelled"] = "Cancelled";
    ExamStatus["Delivered"] = "Delivered";
    ExamStatus["No_Show"] = "No Show";
    ExamStatus["NDA_Refuse"] = "NDA Refused";
})(ExamStatus = exports.ExamStatus || (exports.ExamStatus = {}));
var ExamSyllabus;
(function (ExamSyllabus) {
    ExamSyllabus["EXAM_2007_CIF_Syllabus"] = "2007 CIF Syllabus";
    ExamSyllabus["EXAM_2011_CBA_Syllabus"] = "2011 CBA Syllabus";
    ExamSyllabus["EXAM_2015_Syllabus"] = "2015 Syllabus";
    ExamSyllabus["EXAM_2017_CBA_Syllabus"] = "2017 CBA Syllabus";
    ExamSyllabus["EXAM_2019_Syllabus"] = "2019 Syllabus";
})(ExamSyllabus = exports.ExamSyllabus || (exports.ExamSyllabus = {}));
var ExamType;
(function (ExamType) {
    ExamType["OBJECTIVE_TEST"] = "Objective Test";
    ExamType["CASE_STUDY"] = "Case Study";
    ExamType["APPRENTICE_END_POINT_ASSESSMENT"] = "Apprentice - End Point Assessment";
    ExamType["FLP_COMPETENCY"] = " FLP Competency";
})(ExamType = exports.ExamType || (exports.ExamType = {}));
var ExamAuthStatus;
(function (ExamAuthStatus) {
    ExamAuthStatus["ACTIVE"] = "Active";
    ExamAuthStatus["USED_ON_VUE_BOOKING"] = "Used in pending On Vue booking";
    ExamAuthStatus["USED_IN_CENTRE_BOOKING"] = "Used in pending in-centre booking";
    ExamAuthStatus["CONSUMED_RESULT_NOT_PUBLISHED"] = "Consumed as part of results not published yet";
    ExamAuthStatus["CONSUMED_PASSING_EXAM"] = "Consumed as part of passing the exam";
    ExamAuthStatus["EXEMPTED"] = "Exempted";
    ExamAuthStatus["LOCKED"] = "Locked";
})(ExamAuthStatus = exports.ExamAuthStatus || (exports.ExamAuthStatus = {}));
var ApplicableExamType;
(function (ApplicableExamType) {
    ApplicableExamType["ALL"] = "All";
    ApplicableExamType["OBJECTIVE_TEST"] = "Objective Test";
    ApplicableExamType["CASE_STUDY"] = "Case Study";
})(ApplicableExamType = exports.ApplicableExamType || (exports.ApplicableExamType = {}));
var PersonLevelExemptionStatus;
(function (PersonLevelExemptionStatus) {
    PersonLevelExemptionStatus["DRAFT"] = "Draft";
    PersonLevelExemptionStatus["SUBMITTED"] = "Submitted";
})(PersonLevelExemptionStatus = exports.PersonLevelExemptionStatus || (exports.PersonLevelExemptionStatus = {}));
//# sourceMappingURL=index.js.map